import React, { Component } from 'react';
import homedata from '../../data/home.json';

class Terms extends Component {
    render () {

        let factsInfo = homedata.terms
        let sectionHeadingInfo = factsInfo.sectionHeading

        // H4 styles object
        const h4Style = {
            color: '#333',
            fontSize: '1.5rem',
            fontWeight: '600',
            marginTop: '30px',
            marginBottom: '15px',
            borderLeft: '4px solid #007bff',
            paddingLeft: '15px'
        }



        return     <section id="features" className="pt100 pb100">
        <div className="container">
            <div className="row">
                <div className="col-lg-10 col-md-8 col-sm-10 offset-md-1 offset-sm-1">
                    <div className="section-title text-center mb60">
                        <h2 dangerouslySetInnerHTML={{__html: sectionHeadingInfo.title}}></h2>
                        <hr className="lines"/>
                        <div className="clearfix" style={{ textAlign: 'left',
                             maxWidth: '900px',
      
      padding: '30px',
      background: '#fff',
      
                         }}>
                            <p>
      These Terms and Conditions (“Terms”) govern your use of the website operated by
      <strong>Finneto</strong> (“Company”, “we”, “our”, or “us”), including any related services,
      content, or communications provided through the website.
    </p>

    <p>
      By accessing or using this website, you agree to be bound by these Terms.
      If you do not agree, please do not use the website.
    </p>

    <h4 style={h4Style}>1. Company Information</h4>
    <p>
      Finneto operates through its associated legal entities including:
    </p>
    <ul>
      <li><strong>Lorlir LLC</strong>, Registered in Wyoming, United States</li>
      <li><strong>Finixo IL Ltd</strong>, Registered in Israel</li>
    </ul>
    <p>Contact details are displayed on the website footer.</p>

    <h4 style={h4Style}>2. Use of the Website</h4>
    <p>You agree to use this website only for lawful purposes and in accordance with these Terms. You may not:</p>
    <ul>
      <li>Use the website for any illegal activity</li>
      <li>Attempt to gain unauthorized access to any systems</li>
      <li>Copy, modify, distribute, or resell any content without permission</li>
      <li>Upload malicious software or attempt to disrupt operation</li>
    </ul>
    <p>We reserve the right to restrict or terminate access for any violation.</p>

    <h4 style={h4Style}>3. Nature of Services</h4>
    <p>
      Finneto provides business technology and digital solutions, which may include but are not limited to:
    </p>
    <ul>
      <li>Online marketing</li>
      <li>Data management</li>
      <li>Fintech development</li>
      <li>E-commerce systems</li>
      <li>CRM and analytics platforms</li>
    </ul>
    <p>
      All services are provided on a <strong>business-to-business (B2B)</strong> basis unless otherwise stated
      in a written agreement.
    </p>

    <h4 style={h4Style}>4. No Financial, Legal, or Investment Advice</h4>
    <p>
      Any information provided on this website is for general informational purposes only and does not constitute:
    </p>
    <ul>
      <li>Financial advice</li>
      <li>Legal advice</li>
      <li>Investment advice</li>
      <li>Tax advice</li>
    </ul>
    <p>You should consult qualified professionals before making decisions based on any content provided.</p>

    <h4 style={h4Style}>5. Intellectual Property</h4>
    <p>
      All content on this website, including text, graphics, logos, software, and designs, is the property of Finneto
      or its licensors and is protected by intellectual property laws.
    </p>
    <p>You may not reproduce, distribute, or exploit any content without written consent.</p>

    <h4 style={h4Style}>6. Third-Party Links</h4>
    <p>
      This website may contain links to third-party websites. We are not responsible for the content, policies,
      or practices of any third-party websites. Accessing third-party sites is at your own risk.
    </p>

    <h4 style={h4Style}>7. Limitation of Liability</h4>
    <p>
      To the maximum extent permitted by law, Finneto shall not be liable for:
    </p>
    <ul>
      <li>Any direct or indirect damages</li>
      <li>Loss of profits, data, or business opportunities</li>
      <li>Service interruptions</li>
      <li>Errors or inaccuracies on the website</li>
    </ul>
    <p>Use of the website and services is entirely at your own risk.</p>

    <h4 style={h4Style}>8. Availability & Service Changes</h4>
    <p>We reserve the right to:</p>
    <ul>
      <li>Modify or discontinue any part of the website or services</li>
      <li>Suspend access for maintenance or operational reasons</li>
      <li>Change features, pricing, or service scope without prior notice</li>
    </ul>

    <h4 style={h4Style}>9. Indemnification</h4>
    <p>
      You agree to indemnify and hold harmless Finneto, its directors, officers, employees, and affiliates
      from any claims, losses, damages, liabilities, or legal fees arising from your misuse of the website
      or violation of these Terms.
    </p>

    <h4 style={h4Style}>10. Privacy</h4>
    <p>
      Use of this website is also governed by our <strong>Privacy Policy</strong>, which explains how we collect
      and use personal data.
    </p>

    <h4 style={h4Style}>11. Governing Law</h4>
    <p>
      These Terms shall be governed by and interpreted in accordance with:
    </p>
    <ul>
      <li>The laws of the <strong>State of Wyoming, USA</strong> for Lorlir LLC matters</li>
      <li>The laws of the <strong>State of Israel</strong> for Finixo IL Ltd matters</li>
    </ul>
    <p>Jurisdiction shall be determined based on the relevant contracting entity.</p>

    <h4 style={h4Style}>12. Changes to These Terms</h4>
    <p>
      We reserve the right to update these Terms at any time. Updated versions will be published on this page
      with a revised “Last Updated” date. Continued use of the website constitutes acceptance of the updated Terms.
    </p>

    <h4 style={h4Style}>13. Contact Information</h4>
    <p>
      If you have any questions regarding these Terms, please contact us using the details provided on the website.
    </p>
                        </div>
                        
                    </div>
                </div>
            </div>
       
        </div>
    </section>
    }
}


export default Terms
